import { render, staticRenderFns } from "./MainBidding.vue?vue&type=template&id=c992b38c"
import script from "./MainBidding.vue?vue&type=script&lang=js"
export * from "./MainBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports